import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

import { percentChange } from "./dashboardUtils";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    height: "100%",
  },
  value: {
    fontWeight: 500,
    margin: theme.spacing(0.5, 0),
    fontVariantNumeric: "tabular-nums",
  },
  delta: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  icon: {
    fontSize: 16,
  },
}));

// A headline number with its change vs the previous period. `invert` is for
// metrics where going up is bad (refunds, cancellations).
const KpiTile = ({
  label,
  value,
  current,
  previous,
  invert = false,
  hint,
  compareLabel = "vs previous period",
}) => {
  const classes = useStyles();
  const showDelta = current !== undefined && previous !== undefined;
  const change = showDelta ? percentChange(current, previous) : null;
  const isUp = change !== null && change > 0;
  const isGood = invert ? !isUp : isUp;
  const deltaColor =
    change === null || Math.abs(change) < 0.5
      ? "textSecondary"
      : isGood
      ? "primary"
      : "error";

  return (
    <Paper className={classes.paper}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="h5" component="p" className={classes.value}>
        {value}
      </Typography>
      {showDelta && (
        <Typography
          variant="caption"
          color={deltaColor}
          className={classes.delta}
          component="p"
        >
          {change === null ? (
            "No prior data to compare"
          ) : (
            <>
              {isUp ? (
                <ArrowUpwardIcon className={classes.icon} />
              ) : change < 0 ? (
                <ArrowDownwardIcon className={classes.icon} />
              ) : null}
              {`${Math.abs(change).toFixed(1)}% ${compareLabel}`}
            </>
          )}
        </Typography>
      )}
      {hint && (
        <Typography variant="caption" color="textSecondary" component="p">
          {hint}
        </Typography>
      )}
    </Paper>
  );
};

export default KpiTile;
